import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@spartacus/core';
import { Observable, tap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { GlobalService } from '../global.service';
import { MSALSpaAuthService } from '../login-sso/msal-auth.service';
import * as StorageActions from  '../../store/shared-store/actions/browser-storage.action';
import { Store,select } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class CustomRouteGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private msalService: MsalService,
    private msalAuthService: MSALSpaAuthService,
    private globalService: GlobalService,
    private store: Store
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | UrlTree {
    return this.authService.isUserLoggedIn().pipe(
      tap((isLoggedIn) => {
        if (!isLoggedIn) {
          this.store.dispatch(StorageActions.setRedirectUrl({ redirectUrl: state.url }));
          const usePopup = this.globalService.checkSmartEdit();
          this.msalAuthService.safeLogin(usePopup).catch((err: any) => {
            console.error('[MSAL Guard] Login failed:', err);
          });
        }
      })
    );
  }
}